import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { selectors as membershipSelectors } from '../../../../state/modules/memberships';
import { operations as groupOperations } from '../../../../state/modules/groups';
import {
  selectors as availabilityCodesSelectors,
  operations as availabilityCodesOperations
} from '../../../../state/modules/availability-codes';
import { getCurrentUser } from '../../../../state/modules/current-user/operations';
import { selectCurrentUser } from '../../../../state/modules/current-user/selectors';
import AvailabilityChangeForm from '../../../schedule/availability/AvailabilityChangeForm';

const QuickAvailabilityChangeWidget = ({
  availabilityCodes,
  availabilityCodesLoaded,
  currentUser,
  currentUserPlannableOnCallStationMemberships,
  fetchAvailabilityCodes,
  fetchCurrentUser,
  fetchGroups
}) => {
  useEffect(() => {
    fetchAvailabilityCodes();
    fetchGroups();
    fetchCurrentUser();
  }, []);

  return (
    <AvailabilityChangeForm
      availabilityCodes={availabilityCodes}
      availabilityCodesLoaded={availabilityCodesLoaded}
      currentUser={currentUser}
      currentUserPlannableStationMemberships={currentUserPlannableOnCallStationMemberships}
    />
  );
};

const mapStateToProps = state => ({
  availabilityCodesLoaded: availabilityCodesSelectors.initialLoadComplete(state),
  availabilityCodes: availabilityCodesSelectors.selectSchedulableAvailabilityCodes(state),
  currentUser: selectCurrentUser(state),
  currentUserPlannableOnCallStationMemberships: membershipSelectors.currentUserPlannableOnCallStationMemberships(state)
});

const mapDispatchToProps = {
  fetchAvailabilityCodes: availabilityCodesOperations.fetch,
  fetchCurrentUser: getCurrentUser,
  fetchGroups: groupOperations.fetch
};

Object.assign(QuickAvailabilityChangeWidget, {
  defaultSettings: {
    autoResizeHeight: true
  }
});

export default connect(mapStateToProps, mapDispatchToProps)(QuickAvailabilityChangeWidget);
